import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { Product } from "../../models";

const landingPage = (state: RootState) => state.productCarousel;

export const allProducts = createSelector(landingPage, state => state.products);

export const featuredProducts = createSelector(allProducts, products =>
  Object.values<Product>(products).filter(product => product.status === 2),
);



// WEBPACK FOOTER //
// ./src/routes/ProductCarousel/selectors.ts